/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function RoleReviewer({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M1.375 5A3.625 3.625 0 0 1 5 1.375h6A3.625 3.625 0 0 1 14.625 5v3.119c0 1.461-.913 2.737-1.928 3.717-1.031.998-2.28 1.798-3.176 2.31-.947.54-2.095.54-3.042 0-.897-.512-2.145-1.312-3.176-2.31-1.015-.98-1.928-2.256-1.928-3.717V5ZM5 2.625A2.375 2.375 0 0 0 2.625 5v3.119c0 .942.605 1.908 1.546 2.818.924.894 2.07 1.634 2.927 2.123.564.322 1.24.322 1.804 0 .856-.489 2.003-1.23 2.927-2.123.941-.91 1.546-1.876 1.546-2.818V5A2.375 2.375 0 0 0 11 2.625H5Z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M11.384 5.007a.625.625 0 0 1 .11.877l-3.5 4.5a.625.625 0 0 1-.936.058l-2-2a.625.625 0 1 1 .884-.884l1.5 1.5 3.065-3.942a.625.625 0 0 1 .877-.11Z" clipRule="evenodd" /></svg>;
}
;